/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Modal,
  Select,
  Form,
  Space,
  Upload,
  Spin,
  Row,
  Col,
} from "antd";
import {
  AuditOutlined,
  BackwardOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  CaAdminMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";
import "../../../components/AdminComponents/contactStyles.css";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import { useParams, NavLink } from "react-router-dom";
import Axios from "../../../api/Axios";
import { message } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;
const handleRowClick = () => {};
const record = null;
const ContactAddCA = () => {
  const history = useNavigate();
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [access, setAccess] = useState(false); // "False" is the default value for access
  const [showAdditionalElements, setShowAdditionalElements] = useState(false);
  const [applications, setApplications] = useState([]);
  const [phone, setPhone] = useState("");
  const [newRoles, setNewRoles] = useState();
  const [additionalFieldsCount, setAdditionalFieldsCount] = useState(1);
  const [roles1, setRoles1] = useState([]);
  const [naicsRes, setNaicsRes] = useState([]);
  const [phoneObj, setPhoneObj] = useState(null);
  const handleAccessChange = (value) => {
    setAccess(value);
    //console.log(value);
    setShowAdditionalElements(value);
    setAdditionalFieldsCount(1);
  };
  const [selectedApplications, setSelectedApplications] = useState([]);
  // Set the initial country code

  // ...

  // const handleAppSelection = (value, index) => {
  //   setSelectedApplications((prevSelectedApplications) => {
  //     const updatedSelectedApplications = [...prevSelectedApplications];
  //     updatedSelectedApplications[index] = value;
  //     return updatedSelectedApplications;
  //   });
  // };
  const handleAppSelection = (value, index) => {
    //console.log(value, index);
    setSelectedApplications((prevSelectedApplications) => {
      const updatedSelectedApplications = [...prevSelectedApplications];
      updatedSelectedApplications[index] = value;
      return updatedSelectedApplications;
    });
    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    const selectedApp = applications.find((app) => app.id === value);
    //console.log(applications);
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      if (selectedApp) {
        // set the roles for the selected application
        updatedRoles[index] = selectedApp.roles;
      } else {
        updatedRoles[index] = [];
      }
      return updatedRoles;
    });
  };
  const resetAppAnduser = (ele) => {
    //console.log(ele, "--------------------");
    formRef.current.setFieldsValue({ [`user_role[${ele}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${ele}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[ele] = [];
      return updatedRoles;
    });
  };

  const LoadApplications = async () => {
    //console.log(id);
    try {
      const res = await Axios.get(
        `/contactsapplications/${userInfo.data.organization.id}/`
      );
      //console.log(res.data);
      setApplications(res.data);
      setNewRoles(res.data);
      //console.log(res.data);
      //console.log(Math.min(res.data?.length || 0, 5));
      // setAdditionalFieldsCount(Math.min(res.data?.length || 0, 5));
      //console.log(additionalFieldsCount); // set maximum number of fields to 5 or the length of the data array, whichever is smaller
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const accessRef = useRef(false);
  const onFinish = async (values) => {
    // const { phone_number } = values;
    // console.log(phone_number);
    // const cleanedPhoneNumber = phone_number.replace(/\D/g, "");
    // const formattedPhoneNumber = cleanedPhoneNumber.replace(
    //   /(\d{1})(\d{3})(\d{3})(\d{4})/,
    //   "+$1 ($2) $3-$4"
    // );
    // console.log(formattedPhoneNumber);

    // const countryCode = phoneObj ? phoneObj.countryCallingCode : null;
    // const phoneNumber = phoneObj ? phoneObj.nationalNumber : phone_number;
    // console.log(phoneObj.countryCallingCode);
    // console.log("Submitted phone number:", countryCode + phoneNumber);
    const applications = [];
    for (let i = 0; i < additionalFieldsCount; i++) {
      const application = {
        application: values[`applications[${i}]`],
        role: values[`user_role[${i}]`],
      };
      applications.push(application);
    }
    for (let i = 0; i < additionalFieldsCount; i++) {
      delete values[`applications[${i}]`];
      delete values[`user_role[${i}]`];
    }
    //console.log(applications);
    const organizationId = parseInt(id);
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    // const phoneNumberWithPlus = "+" + phone;
    const updatedValues = {
      ...normalizedValues,
      organization: organizationId,
      // applications: applications,
      // created_by: userInfo?.data?.id,
      // phone_number: phoneNumberWithPlus,
    };

    if (phone && phone.length > 4 && !phone.startsWith("+")) {
      updatedValues.phone_number = "+" + phone;
    } else if (phone && phone.length > 4 && phone.startsWith("+")) {
      updatedValues.phone_number = phone;
    } else {
      updatedValues.phone_number = "";
    }

    //console.log("Form values:", updatedValues);
    try {
      const res = await Axios.post("/contactscreate/", updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      if (err?.response?.data?.detail?.phone_number) {
        CreateFailed(`${err?.response?.data?.detail?.phone_number}`);
      } else if (err?.response?.data?.detail) {
        CreateFailed(err?.response?.data?.detail);
      } else {
        CreateFailed("Contact have not been created");
      }
      //console.log(err.response.data.detail);
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Conatct has been created.",
      duration: 5,
    });
    // LoadContacts();
    setTimeout(() => {
      history(`/ca-admin/organization/profile/relationships`);
    }, 5000);
  };
  const handleAccessReset = (index) => {
    // setAdditionalFieldsCount(0);
    //console.log("-------------------------------");
    //console.log(additionalFieldsCount);
    formRef.current.setFieldsValue({ access: false });
    setShowAdditionalElements(false);

    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${index}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[index] = [];
      return updatedRoles;
    });
  };
  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Contact have not been created.",
      duration: 5,
    });
  };
  const formRef = useRef();
  const handleSubmit = async (values) => {
    const applications = [];
    for (let i = 0; i < additionalFieldsCount; i++) {
      const application = {
        application: values[`applications[${i}]`],
        role: values[`user_role[${i}]`],
      };
      applications.push(application);
    }
    //console.log(applications);
  };

  const handleReset = () => {
    formRef.current.resetFields();
    setShowAdditionalElements(false);
  };
  useEffect(() => {
    //console.log(additionalFieldsCount);
    //console.log(roles1);
  }, [additionalFieldsCount, roles1]);

  // const [naicsRes, setNaicsRes] = useState([]);
  const [selectedNaics, setSelectedNaics] = useState("");

  const handleNaicsSearch = async (value) => {
    //console.log(value);
    if (value.length >= 2) {
      const response = await Axios.get(
        `/locationlist/${userInfo.data.organization.id}/?search=${value}`
      );
      //console.log(response);
      setNaicsRes(response.data);
    } else {
      setNaicsRes([]);
    }
  };

  const handleNaicsSelect = (value) => {
    setSelectedNaics(value);
  };

  const handleNaicsBlur = () => {
    if (!selectedNaics) {
      setSelectedNaics("");
    }
  };
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);

    setPhone(value);
  };
  const phoneInputRef = useRef();
  return (
    <div>
      <CaSideNav props={CaAdminMenu}>
        {contextHolder}
        <SecondaryNav2 id={parseInt(id)} menuItems={SecondaryNavCaAdmin} />
        <div className="light-bar-container">
          {/* <nav> */}
          <NavLink
            to={`/ca-admin/organization/profile/relationships/add-contact/${userInfo.data.organization.id}`}
            className={(navigationData) =>
              navigationData.isActive
                ? "link-heading-latest-active"
                : "link-heading-latest"
            }
            style={{ paddingLeft: "3rem" }}
          >
            <span>
              <AuditOutlined />
            </span>
            Add Contact
          </NavLink>

          {/* </nav> */}
        </div>
        <div className="form-container-2">
          <Form
            name="complex-form"
            onFinish={onFinish}
            layout="vertical"
            ref={formRef}
            labelCol={{
              span: 25,
            }}
            wrapperCol={{
              span: 80,
            }}
            style={{
              width: "100%",
              marginBottom: "150px",
            }}
          >
            <div className="group1">
              <div className="form-heading">
                {capitalizeWords("ADD CONTACT INFO")}
              </div>
              <div className="antd-test-client" style={{ marginTop: "2rem" }}>
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">First Name</p>}
                    >
                      <Form.Item
                        name="first_name"
                        noStyle
                        rules={[
                          { required: true, message: "Username is required" },
                        ]}
                      >
                        <Input
                          className="my-form-input-antd-test"
                          placeholder={"Enter user name"}
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Last Name</p>}
                    >
                      <Form.Item name="last_name" noStyle initialValue={null}>
                        <Input
                          placeholder="Enter last name"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={7} xl={7}>
                    <Form.Item label={<p className="my-form-lables">Email</p>}>
                      <Form.Item
                        name="email"
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "Enter a valid email",
                            type: "email",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Email"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Position</p>}
                    >
                      <Form.Item
                        name="job_title"
                        noStyle
                        initialValue={null}
                        rules={[
                          {
                            required: access, // Make it required when access is true
                            message: "Please enter a position", // Error message if not filled
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Position"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div className="antd-test-client">
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <div style={{ display: "inline-block", marginLeft: "1rem" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Phone No.</p>}
                    >
                      <Space>
                        <Form.Item noStyle name="phone_number">
                          <PhoneInput
                            // className="my-form-input"
                            ref={phoneInputRef}
                            placeholder="Enter your Phone No."
                            country="us"
                            value={phone}
                            // style={{ width: "27rem" }}
                            onChange={handlePhoneNumberChange}
                            onBlur={() => {
                              try {
                                const phoneObj =
                                  parsePhoneNumberFromString(phone);
                                setPhoneObj(phoneObj);
                              } catch (e) {
                                setPhoneObj(null);
                              }
                            }}
                          />
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>

                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item label={<p className="my-form-lables">Status</p>}>
                      <Input.Group compact>
                        <Form.Item name="status" noStyle initialValue={true}>
                          <Select
                            placeholder="Select Status"
                            className="my-form-input-antd-test"
                          >
                            <Option value={true}>Active</Option>
                            <Option value={false}>Inactive</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">System Access</p>}
                    >
                      <Input.Group compact>
                        <Form.Item name="access" noStyle initialValue={false}>
                          <Select
                            placeholder="Select Access"
                            className="my-form-input-antd-test"
                            // value={accessRef.current}
                            onChange={handleAccessChange}
                          >
                            <Option value={true}>Yes</Option>
                            <Option value={false}>No</Option>
                          </Select>
                        </Form.Item>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">User ID</p>}
                    >
                      <Form.Item
                        name="user_id"
                        noStyle
                        initialValue={null}
                        rules={[
                          {
                            max: 11,
                            message: "max length 11 characters",
                          },
                        ]}
                      >
                        <Input
                          className="my-form-input-antd-test"
                          placeholder="Enter user ID"
                          disabled={!showAdditionalElements}
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              {/* {showAdditionalElements && (
              <div className="group-1-box" style={{ marginTop: "2rem" }}>
                <div style={{ display: "inline-block" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Applications</p>}
                  >
                    <Input.Group compact>
                      <Form.Item name="applications" noStyle initialValue={[]}>
                        <Select
                          placeholder="Select Type"
                          className="my-form-input"
                          style={{ width: "26rem" }}

                        >
                          {applications?.map((app) => (
                            <Option key={app.id} value={app.id}>
                              {app.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item
                    label={<p className="my-form-lables">User Role</p>}
                  >
                    <Input.Group compact>
                      <Form.Item name="user_role" noStyle>
                        <Input
                          placeholder="Enter user role"
                          className="my-form-input"
                          style={{ width: "26rem" }}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
              </div>
            )} */}
              {showAdditionalElements && (
                // <div className="group-1-box" style={{ marginTop: "2rem" }}>
                <div className="antd-test-client">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Roles</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="roles" noStyle initialValue={[]}>
                            <Select
                              placeholder="Select Roles"
                              className="my-form-input-antd-test"
                              mode="multiple"
                              // onChange={handleRoleSelection}
                            >
                              {newRoles?.map((role) => (
                                <Option key={role.id} value={role.id}>
                                  {role.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Location</p>}
                      >
                        <Form.Item name="location" noStyle>
                          <Select
                            showSearch
                            placeholder="Enter Location"
                            filterOption={false}
                            className="my-form-input-antd-test"
                            onSearch={handleNaicsSearch}
                            onSelect={handleNaicsSelect}
                            onBlur={handleNaicsBlur}
                            value={selectedNaics}
                          >
                            {naicsRes.map((naics) => (
                              <Option key={naics.id} value={naics.id}>
                                {`${naics.name}`}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
            <div style={{ display: "inline-block", marginLeft: "5rem" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  style={{
                    background: "#D3D3D3",
                  }}
                  onClick={() => {
                    history(`/ca-admin/organization/profile/relationships`);
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button type="primary" htmlType="button" onClick={handleReset}>
                  Reset
                </Button>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  // className="my-form-input-end"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                >
                  Save
                  <SaveOutlined />
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </CaSideNav>
    </div>
  );
};

export default ContactAddCA;
